import { Grid2 } from "components";
import { useFetchQuery } from "hooks/useQueries";
import { ModelPortfolioObjectInterface } from "interfaces/EquityBasket";
import { PortfolioSummary } from "Pages";
import { useParams } from "react-router-dom";
import HoldingsSunburst from "./HoldingsSunburst";

interface Props {
  selectedId: any;
  oldIdSelected: any;
  selectedModelPortfolio?: ModelPortfolioObjectInterface;
}

const ModelOverview = (props: Props) => {
  const { selectedId, oldIdSelected, selectedModelPortfolio } = props;

  const { id } = useParams();

  const { data } = useFetchQuery({
    key: ["GET_MODEL_PORTFOLIO_HOLDINGS", oldIdSelected],
    route: `/model_portfolio/${id}/version/${
      oldIdSelected?.snapshotVersion || selectedId
    }/version_holdings/`,
    enabled: Boolean(selectedId),
  });

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <PortfolioSummary selectedModelPortfolio={selectedModelPortfolio} />
      </Grid2>
      <Grid2 size={12}>
        {data?.data?.data && <HoldingsSunburst form={data?.data?.data?.data} />}
      </Grid2>
    </Grid2>
  );
};

export default ModelOverview;
